import { useQuery } from "urql"

import type {
  GetLocationMaterialRequirementsPreferenceQuery,
  LocationMaterialRequirementsPreference,
} from "@/graphql/codegen/graphql"
import { GetLocationMaterialRequirementsPreferenceDocument } from "@/graphql/codegen/graphql"

interface UseGetMaterialRequirementsResult {
  preference: LocationMaterialRequirementsPreference | null
  isFetching: boolean
  refetch: () => void
}

export const useGetMaterialRequirements = (locationId: string): UseGetMaterialRequirementsResult => {
  const [result, refetch] = useQuery<GetLocationMaterialRequirementsPreferenceQuery>({
    query: GetLocationMaterialRequirementsPreferenceDocument,
    variables: {
      shipToLocationId: locationId,
    },
  })

  const data =
    result.data?.locationMaterialRequirementsPreference.get.__typename ===
    "LocationMaterialRequirementsPreferenceGetSuccess"
      ? result.data.locationMaterialRequirementsPreference.get.preference
      : null

  return {
    preference: data ?? null,
    isFetching: result.fetching,
    refetch: () => {
      refetch({ requestPolicy: "network-only" })
    },
  }
}
